import { Button } from "@overmap-ai/blocks"
import { type ComponentProps, memo, use } from "react"

import { FilterRendererContext } from "../contexts/FilterRendererContext/context"

interface FilterCellButtonProps extends ComponentProps<typeof Button> {}

export const FilterCellButton = memo<FilterCellButtonProps>((props) => {
	const filterRendererContext = use(FilterRendererContext)
	const {
		ref,
		accentColor = "base",
		children,
		size = filterRendererContext.size,
		variant = filterRendererContext.variant,
		...rest
	} = props

	return (
		<Button ref={ref} accentColor={accentColor} size={size} variant={variant} {...rest}>
			{children}
		</Button>
	)
})
FilterCellButton.displayName = "FilterCellButton"
